import { render, staticRenderFns } from "./ToggleRating.vue?vue&type=template&id=22b41cc2&scoped=true"
import script from "./ToggleRating.vue?vue&type=script&lang=js"
export * from "./ToggleRating.vue?vue&type=script&lang=js"
import style0 from "./ToggleRating.vue?vue&type=style&index=0&id=22b41cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b41cc2",
  null
  
)

export default component.exports